<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1102001000012ogauc.vue
*@ 컴포넌트설명 :[오클랜드] 예금 상품 > 예금 상품 상세(정기예금(사업자용))
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
** 2022.10.06   이가영  오클랜드 금리 변경
** 2022.10.31   이가영  오클랜드 금리 변경
** 2022.12.02   이가영  오클랜드 금리 변경
** 2023.03.27   이가영  오클랜드 금리 변경
** 2023.04.28   이가영  오클랜드 금리변경
** 2023.07.10   이가영  오클랜드 금리변경
********************************************************************************/
-->
<template>
  <section class="deposit detail">
    <!--한국어-->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>정기예금(사업자용)</h2>
          </div>
          <div class="description">
            <p>목돈을 일정기간동안 예치하여 안정적인 수익을 목적으로 하는 일시예치식 예금</p>
          </div>
          <!-- 금리 이율 + 최소가입금액 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="text">최대 연</span>
              </div>
              <div class="percent">4.80%</div>
              <div class="etc">(아래참조)</div>
            </div>
          </div>
          <!--// 금리 이율 + 최소가입금액 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>상품유형</dt>
            <dd>정기예금</dd>
            <dt>상품개요</dt>
            <dd>목돈을 일정기간 동안 예치하여 안정적인 수익을 목적으로 하는 일시예치식 상품</dd>
            <dt>가입대상</dt>
            <dd>실명의 법인 및 개인사업자</dd>
            <dt>계약기간</dt>
            <dd>
              NZD : 최저 7일 ~ 최장 5년
              <br />USD : 31일, 61일, 92일, 183일 (1개월, 2개월, 3개월, 6개월)<br />
              <p style="color: red">12개월 초과 정기예적금 상품은 비대면 채널을 통한 가입이 어려우므로 신규를 원하시는 경우 영업점으로 문의 부탁드립니다.</p>
            </dd>
            <dt>가입통화</dt>
            <dd>NZD, USD</dd>
            <dt>가입금액</dt>
            <dd>
              NZD 5,000.00 이상
              <br />USD 5,000.00 이상
            </dd>
            <dt>금리 및 이율</dt>
            <dd>
              약정이율
              <br />통화 : NZD
            </dd>
          </dl>
          <div class="tbl-top-etc">(연이율, 세전, 단위 : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th scope="col">정기예금</th>
                <th scope="col">
                  $5,000
                  <em>이상</em>
                </th>
                <th scope="col">
                  $10,000
                  <em>이상</em>
                </th>
                <th scope="col">
                  $50,000
                  <em>이상</em>
                </th>
                <th scope="col">
                  $100,000
                  <em>이상</em>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  7D~1M
                  <em>미만</em>
                </th>
                <td>
                  0
                  <em>.00</em>
                </td>
                <td>
                  0
                  <em>.00</em>
                </td>
                <td>
                  0
                  <em>.00</em>
                </td>
                <td>
                  0
                  <em>.00</em>
                </td>
              </tr>
              <tr>
                <th scope="row">1M</th>
                <td>
                  2
                  <em>.10</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
              </tr>
              <tr>
                <th scope="row">2M</th>
                <td>
                  2
                  <em>.10</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
              </tr>
              <tr>
                <th scope="row">3M</th>
                <td>
                  3
                  <em>.60</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
              </tr>
              <tr>
                <th scope="row">4M</th>
                <td>
                  3
                  <em>.60</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
              </tr>
              <tr>
                <th scope="row">5M</th>
                <td>
                  4
                  <em>.00</em>
                </td>
                <td>
                  4
                  <em>.10</em>
                </td>
                <td>
                  4
                  <em>.10</em>
                </td>
                <td>
                  4
                  <em>.10</em>
                </td>
              </tr>
              <tr>
                <th scope="row">6M</th>
                <td>
                  4
                  <em>.50</em>
                </td>
                <td>
                  4
                  <em>.60</em>
                </td>
                <td>
                  4
                  <em>.60</em>
                </td>
                <td>
                  4
                  <em>.80</em>
                </td>
              </tr>
              <tr>
                <th scope="row">9M</th>
                <td>
                  4
                  <em>.40</em>
                </td>
                <td>
                  4
                  <em>.50</em>
                </td>
                <td>
                  4
                  <em>.50</em>
                </td>
                <td>
                  4
                  <em>.60</em>
                </td>
              </tr>
              <tr>
                <th scope="row">1Y</th>
                <td>
                  4
                  <em>.10</em>
                </td>
                <td>
                  4
                  <em>.20</em>
                </td>
                <td>
                  4
                  <em>.20</em>
                </td>
                <td>
                  4
                  <em>.30</em>
                </td>
              </tr>
              <tr>
                <th scope="row">2Y</th>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
              </tr>
              <tr>
                <th scope="row">3Y</th>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
              </tr>
              <tr>
                <th scope="row">4Y</th>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
              </tr>
              <tr>
                <th scope="row">5Y</th>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· 중도해지 : 약정이율 -2% 또는 0%</p>
            <p>· 만기이후이율 : 약정이율 ÷ 2</p>
            <p>· 모든 예금이율은 시장금리상황에 따라 변동이 있을수 있습니다.</p>
          </div>

          <div class="info info-type3">
            <p>통화 : USD</p>
          </div>
          <div class="tbl-top-etc">(연이율, 세전, 단위 : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="division" scope="col"></th>
                <th scope="col">
                  $5,000
                  <em>이상</em>
                </th>
                <th scope="col">
                  $10,000
                  <em>이상</em>
                </th>
                <th scope="col">
                  $50,000
                  <em>이상</em>
                </th>
                <th scope="col">
                  $100,000
                  <em>이상</em>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  31
                  <em>일</em>
                </th>
                <td>
                  2
                  <em>.40</em>
                </td>
                <td>
                  3
                  <em>.00</em>
                </td>
                <td>
                  3
                  <em>.00</em>
                </td>
                <td>
                  3
                  <em>.00</em>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  61
                  <em>일</em>
                </th>
                <td>
                  2
                  <em>.40</em>
                </td>
                <td>
                  3
                  <em>.00</em>
                </td>
                <td>
                  3
                  <em>.30</em>
                </td>
                <td>
                  3
                  <em>.30</em>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  92
                  <em>일</em>
                </th>
                <td>
                  2
                  <em>.80</em>
                </td>
                <td>
                  3
                  <em>.30</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  183
                  <em>일</em>
                </th>
                <td>
                  3
                  <em>.00</em>
                </td>
                <td>
                  3
                  <em>.60</em>
                </td>
                <td>
                  4
                  <em>.00</em>
                </td>
                <td>
                  4
                  <em>.00</em>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type4">
            <strong>수수료</strong>
            <p>해당무</p>
          </div>
          <div class="info info-type3">
            <p>· 중도해지 : 약정이율 -2% 또는 0%</p>
            <p>· 만기이후이율 : 약정이율 ÷ 2</p>
            <p>· 모든 예금이율은 시장금리상황에 따라 변동이 있을수 있습니다.</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>가입방법</strong>
            <p>영업점가입, 인터넷 가입</p>
          </div>
          <div class="info info-type4">
            <strong>가입시 필요서류</strong>
            <p>- 대표이사 및 운영권자의 신분증</p>
            <p>- 법인단체 정관 등</p>
            <p>※ 기타 자세한 필요서류는 영업점으로 문의하시기 바랍니다.</p>
          </div>
          <div class="info info-type4">
            <strong>유의사항 및 기타</strong>
            <p>- 만기지급식</p>
            <p>- 월이자지급식 (NZD 예금만 가능하며, 영업점에서만 신규가 가능합니다.)</p>
          </div>
        </article>
      </div>
    </template>
    <!--영어-->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
          <div class="title">
            <h2>BUSINESS TERM DEPOSIT</h2>
          </div>
          <div class="description">
            <p>A savings account that allows you to build your savings by making a term deposit for the fixed period of time.</p>
          </div>
          <!-- 금리 이율 + 최소가입금액 있을 경우 -->
          <div v-if="true" class="summary">
            <div class="item item-row">
              <div class="tit">
                <span class="text">Up to</span>
              </div>
              <div class="percent">4.80%</div>
              <div class="etc">p.a(Refer to information below)</div>
            </div>
          </div>
          <!--// 금리 이율 + 최소가입금액 있을 경우 end -->
        </article>
        <article class="contents">
          <dl class="dlist dlist-item--type5">
            <dt>Types</dt>
            <dd>Term Deposit</dd>
            <dt>About the products</dt>
            <dd>A savings account that allows you to build your savings by making a term deposit for the fixed period of time.</dd>
            <dt>Eligibilty</dt>
            <dd>Corporations and individual business owners</dd>
            <dt>Contract Terms</dt>
            <dd>
              NZD : From 7 days to 5 years
              <br />USD : 31 days, 61 days, 92 days, 183 day (1 month, 2 months, 3 months, 6 months)<br />
              <p style="color: red">For enquiries on 12 Months exceed deposit products, please contact the branch.</p>
            </dd>
            <dt>Available currency</dt>
            <dd>NZD, USD</dd>
            <dt>Deposit amount</dt>
            <dd>
              Over NZD 5,000.00
              <br />Over USD 5,000.00
            </dd>
            <dt>Rates</dt>
            <dd>
              The agreed interest rate
              <br />Currency : NZD
            </dd>
          </dl>
          <div class="tbl-top-etc">(annual interest rate, pretax, unit : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th scope="col">Term Deposit</th>
                <th scope="col">Over $5,000</th>
                <th scope="col">Over $10,000</th>
                <th scope="col">Over $50,000</th>
                <th scope="col">Over $100,000</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  7D~less
                  <em>1M</em>
                </th>
                <td>
                  0
                  <em>.00</em>
                </td>
                <td>
                  0
                  <em>.00</em>
                </td>
                <td>
                  0
                  <em>.00</em>
                </td>
                <td>
                  0
                  <em>.00</em>
                </td>
              </tr>
              <tr>
                <th scope="row">1M</th>
                <td>
                  2
                  <em>.10</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
              </tr>
              <tr>
                <th scope="row">2M</th>
                <td>
                  2
                  <em>.10</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
                <td>
                  2
                  <em>.20</em>
                </td>
              </tr>
              <tr>
                <th scope="row">3M</th>
                <td>
                  3
                  <em>.60</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
              </tr>
              <tr>
                <th scope="row">4M</th>
                <td>
                  3
                  <em>.60</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
              </tr>
              <tr>
                <th scope="row">5M</th>
                <td>
                  4
                  <em>.00</em>
                </td>
                <td>
                  4
                  <em>.10</em>
                </td>
                <td>
                  4
                  <em>.10</em>
                </td>
                <td>
                  4
                  <em>.10</em>
                </td>
              </tr>
              <tr>
                <th scope="row">6M</th>
                <td>
                  4
                  <em>.50</em>
                </td>
                <td>
                  4
                  <em>.60</em>
                </td>
                <td>
                  4
                  <em>.60</em>
                </td>
                <td>
                  4
                  <em>.80</em>
                </td>
              </tr>
              <tr>
                <th scope="row">9M</th>
                <td>
                  4
                  <em>.40</em>
                </td>
                <td>
                  4
                  <em>.50</em>
                </td>
                <td>
                  4
                  <em>.50</em>
                </td>
                <td>
                  4
                  <em>.60</em>
                </td>
              </tr>
              <tr>
                <th scope="row">1Y</th>
                <td>
                  4
                  <em>.10</em>
                </td>
                <td>
                  4
                  <em>.20</em>
                </td>
                <td>
                  4
                  <em>.20</em>
                </td>
                <td>
                  4
                  <em>.30</em>
                </td>
              </tr>
              <tr>
                <th scope="row">2Y</th>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
              </tr>
              <tr>
                <th scope="row">3Y</th>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
              </tr>
              <tr>
                <th scope="row">4Y</th>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
              </tr>
              <tr>
                <th scope="row">5Y</th>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
                <td>
                  3
                  <em>.90</em>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· Early withdrawals : an agreed rate -2% or 0%</p>
            <p>· After maturity date : agreed interest rate / 2</p>
            <p>· All savings interest rates are subject to change according to market interest rate trends.</p>
          </div>
          <br />
          <div class="info info-type3">
            <p>Currency : USD</p>
          </div>
          <div class="tbl-top-etc">(annual interest rate, pretax, unit : %)</div>
          <table class="table -type01">
            <thead>
              <tr>
                <th class="division" scope="col"></th>
                <th scope="col">Over $5,000</th>
                <th scope="col">Over $10,000</th>
                <th scope="col">Over $50,000</th>
                <th scope="col">Over $100,000</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">
                  31
                  <em>Days</em>
                </th>
                <td>
                  2
                  <em>.40</em>
                </td>
                <td>
                  3
                  <em>.00</em>
                </td>
                <td>
                  3
                  <em>.00</em>
                </td>
                <td>
                  3
                  <em>.00</em>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  61
                  <em>Days</em>
                </th>
                <td>
                  2
                  <em>.40</em>
                </td>
                <td>
                  3
                  <em>.00</em>
                </td>
                <td>
                  3
                  <em>.30</em>
                </td>
                <td>
                  3
                  <em>.30</em>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  92
                  <em>Days</em>
                </th>
                <td>
                  2
                  <em>.80</em>
                </td>
                <td>
                  3
                  <em>.30</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
                <td>
                  3
                  <em>.70</em>
                </td>
              </tr>
              <tr>
                <th scope="row">
                  183
                  <em>Days</em>
                </th>
                <td>
                  3
                  <em>.00</em>
                </td>
                <td>
                  3
                  <em>.60</em>
                </td>
                <td>
                  4
                  <em>.00</em>
                </td>
                <td>
                  4
                  <em>.00</em>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="info info-type3">
            <p>· Early withdrawals : an agreed rate -2% or 0%</p>
            <p>· After maturity date : agreed interest rate / 2</p>
            <p>· All savings interest rates are subject to change according to market interest rate trends.</p>
          </div>
          <br />
          <div class="info info-type4">
            <strong>Fees</strong>
            <p>N/A</p>
          </div>
          <div class="info info-type4">
            <strong>How to apply</strong>
            <p>Apply at the branch, Apply Online</p>
          </div>
          <div class="info info-type4">
            <strong>Required documents for application</strong>
            <p>- Directors or Operating Manager's ID</p>
            <p>- Articles of incorporation, etc.</p>
            <p>※ Please contact our branch for more detailed information on required documents.</p>
          </div>
          <div class="info info-type4">
            <strong>Notices and others</strong>
            <p>- At Maturity Only on Internet Banking</p>
            <p>- Monthly interest rate payment type (Only deposits in NZD is possible and only at the branch.)</p>
          </div>
        </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields(["lang"]),
  },
};
</script>
